import { type DefaultRootState } from '@databases/redux';
import { type DatabaseViewSettings } from '@databases/types/database/view';
import { intersection } from '@databases/utils/set-utils/set-intersection';

import { selectGroupsAndSubgroupsByKey } from './select-groups-and-subgroups-by-key';

const EMPTY_ENTRIES: Set<string> = new Set();

/** Returns the set of entries with matching values for the given group / subgroup. */
export function selectEntriesWithGrouping(
  state: DefaultRootState,
  {
    contentId,
    viewSettings,
    viewId,
    groupKey,
    subgroupKey,
  }: {
    contentId: string;
    viewSettings: DatabaseViewSettings;
    viewId: string;
    groupKey: string;
    subgroupKey?: string;
  }
): Set<string> {
  const { entriesByGroup, entriesBySubgroup } = selectGroupsAndSubgroupsByKey(state, {
    contentId,
    viewSettings,
    viewId,
  });

  if (!entriesByGroup) {
    return EMPTY_ENTRIES;
  }

  const groupEntries = entriesByGroup[groupKey] || EMPTY_ENTRIES;

  // When not subgrouping, just return the group's entries
  if (!subgroupKey || !entriesBySubgroup) {
    return groupEntries;
  }

  // With subgrouping enabled, return the intersection of the group's and subgroup's entries
  const subgroupEntries = entriesBySubgroup[subgroupKey] || EMPTY_ENTRIES;
  return intersection(groupEntries, subgroupEntries);
}
